import { BillingDetailsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/billing-details')({
  component: BillingDetailsRoute,
});
